import { KeyboardAlphaComponent } from '../components/keyboard/alphanumeric/keyboard-alpha/keyboard-alpha.component';
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { KeyboardNumComponent } from '../components/keyboard/numeric/keyboard-num/keyboard-num.component';

@Directive({
  selector: 'input[showMatKeyboard], textarea[showMatKeyboard]',
  exportAs: 'showMatKeyboard',
  standalone: false
})
export class ShowMatKeyboardDirective implements OnDestroy {
  private _keyboardRef:
    | MatDialogRef<KeyboardAlphaComponent, any>
    | MatDialogRef<KeyboardNumComponent, any>;

  @Input() showMatKeyboard: string;

  @Input() manualTrigger: boolean = false;

  constructor(
    private _elementRef: ElementRef,
    private translate: TranslateService,
    private matDialog: MatDialog,
    @Optional() @Self() private _control?: NgControl
  ) {}

  ngOnDestroy() {}

  @HostListener('click')
  _onClickHandler() {
    if (!this.manualTrigger) {
      this._showKeyboard();
    }
  }

  public openKeyboard(): void {
    this._showKeyboard();
  }

  private _showKeyboard() {
    if (
      this.showMatKeyboard == null ||
      this.showMatKeyboard == undefined ||
      this.showMatKeyboard == ''
    )
      this.showMatKeyboard = this.translate.currentLang.split('_')[0];

    let cdk = document.querySelector('.cdk-overlay-container');
    if (cdk) {
      cdk.classList.toggle('d-none');
    }
    // if (this.baseAppService.getShowScreenKeyboard())
    // {
    if (this.showMatKeyboard === 'numpad') {
      this._keyboardRef = this.matDialog.open(KeyboardNumComponent, {
        data: this._elementRef.nativeElement,
        id: 'keyboard'
      });
    } else {
      this._keyboardRef = this.matDialog.open(KeyboardAlphaComponent, {
        data: this._elementRef.nativeElement,
        id: 'keyboard'
      });
    }

    this._keyboardRef.afterClosed().subscribe((result) => {
      document
        .querySelector('.cdk-overlay-container')
        ?.classList.toggle('d-none');
    });

    this._elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });

    // }
  }
}
